<template>
    <DataTable
        data-key="id"
        ref="dt"
        :value="tableData"
        v-model:selection="selectedProducts"

        :paginator="(tableOptions.paginator === undefined || tableOptions.paginator == true) ?( tableData && tableData.length > 0 ? true : false) : false"
        :rows="(tableOptions.paginator === undefined || tableOptions.paginator == true) ? rowsPerPage : 1"
        :rowsPerPageOptions="rowsPerPageOptions"
        :first="(lazyParam.page - 1) * rowsPerPage || 0"

        :showFilterMenu="true"
        v-model:filters="filters"
        :filters="filters"
        filterDisplay="menu"

        :paginatorPosition="tableOptions.paginatorPosition || 'both'"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput RowsPerPageDropdown"
        :currentPageReportTemplate="TR.table_page_info"

        responsiveLayout="scroll"
        :reorderableColumns="false"
        sortMode="multiple"
        :removableSort="true"
        :maxConstraints="G.columnMaxConstraints"
        :exportFilename="tableOptions.export_filename !== undefined ? tableOptions.export_filename : 'download'"
        :exportFunction="expF"
        :rowClass="tableRowClass"
        :stripedRows="false"

        :lazy="true"
        :loading="loading"
        :totalRecords="totalRecords || 0"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"

        :globalFilterFields="tableOptions.globalFilterFields"
        class="dtlazy-main"

        :highlightOnSelect="true"
        :showGridlines="true"

        v-model:expandedRows="expandedRows"
        @rowExpand="onRowExpand"
        @rowCollapse="onRowCollapse"
        :expandedRowIcon="tableOptions.expandIcon"
        :collapsedRowIcon="tableOptions.collapseIcon"

        :rowHover="true"
        @rowClick="tableOptions.rowClick !== undefined ? tableOptions.rowClick($event) : null"
    >
        <template #empty>
            <div class="d-flex justify-content-sm-center">{{TR.emptyFilterMessage}}</div>
        </template>
        <template #loading><i class='fas fa-spinner fa-spin me-2'></i> {{ TR.loading }}</template>


        <template #paginatorstart>
            <Button v-if="tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select" label="" :title="TR.remove" class="ms-21 me-3 p-2" icon="fas fa-trash" severity="danger" outlined @click="deleteSelectedProducts" :disabled="!selectedProducts || !selectedProducts.length" />

            <MultiSelect
                v-if="tableOptions.visibleColumnsBtn === undefined || tableOptions.visibleColumnsBtn == true"
                v-model="selectedColumns"
                :options="table_columns"
                optionValue="value"
                optionLabel="label"
                :maxSelectedLabels="0"
                display="chip"
                class="border-0 p-2"
                :title="TR.select_columns"
            >
                <template #option="slotProps">
                    <div class="d-flex align-items-center" style="width: 180px;">
                        <div
                            v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                        ></div>
                    </div>
                </template>
                <template #dropdownicon>
                    <i class="fas fa-list" />
                </template>
            </MultiSelect>
        </template>
        <template #paginatorend>
        </template>

        <template #header>
            <div class="table-header d-flex flex-column flex-sm-row justify-content-start">
                <button
                    v-if="tableOptions.filterClearBtn === undefined || tableOptions.filterClearBtn == true"
                    type="button"
                    :title="TR.clear"
                    class="mb-2 mb-sm-0 me-sm-4 btn btn-outline-danger"
                    @click="clearFilter()"
                >
                    <i class="fas fa-filter"></i>
                    {{ TR.clear_filter }}
                </button>

                <template v-if="tableOptions.header_buttons && tableOptions.header_buttons.length">
                    <template v-for="(btn, bi) in tableOptions.header_buttons" :key="bi">
                        <button
                            v-if="btn.private === undefined || (typeof btn.private === 'function' ? (btn.private(btn) === false ? true : false) : (btn.private === false ? true : false))"
                            :title="btn.title !== undefined ? btn.title : ''"
                            :class="`mb-2 mb-sm-0 me-sm-3 btn ${btn.class}`"
                            @click="typeof btn.eventCallback === 'function' ? btn.eventCallback($event) : null"
                        >
                            <i :class="btn.icon"></i>
                            {{btn.label}}
                        </button>
                    </template>
                </template>

                <button
                    v-if="tableOptions !== undefined && (tableOptions.export_button !== undefined && tableOptions.export_button == true)"
                    type="button"
                    :title="TR.word_download_btn"
                    class="me-3 ms-sm-auto btn btn-outline-primary"
                    @click="exportFile('word')"
                >
                    <i class="fas fa-file-word"></i>
                    {{ TR.word_download_btn }}
                </button>
                <button
                    v-if="tableOptions !== undefined && (tableOptions.export_button !== undefined && tableOptions.export_button == true)"
                    type="button"
                    :title="TR.excel_download_btn"
                    class="me-3 ms-sm-auto1 btn btn-outline-success"
                    @click="exportFile('excel')"
                >
                    <i class="fas fa-file-excel"></i>
                    {{ TR.excel_download_btn }}
                </button>
            </div>
        </template>

        <Column v-if="tableOptions.row_expander !== undefined && tableOptions.row_expander"
            expander
            style="width: 3rem"
        >
        </Column>

        <Column
            v-if="tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select"
            style="width: 3rem;"
            class="text-center"
            :exportable="false"
            :reorderableColumn="false"
            selectionMode="multiple"
        ></Column>

        <template #expansion="slotProps">
            <div v-if="tableOptions.row_expander !== undefined && tableOptions.row_expander" class="p-2">
                <DADataTable
                    ref="expand_table_ref"
                    v-if="tableOptions.expandTableOptions"
                    :tableData="slotProps.data.items"
                    :tableOptions="tableOptions.expandTableOptions"
                />
            </div>
        </template>

        <Column
            v-if="tableOptions.rowNumber === undefined || tableOptions.rowNumber === true"
            :exportable="false"
            :sortable="false"
            :reorderableColumn="false"
            style="width: 4rem;"
            class="text-center"
            :header="TR.rank"
        >
            <template #body="{index}">{{dt !== null && dt != undefined && dt.d_first !== undefined ? dt.d_first+index+1 : ''}}</template>
        </Column>

        <Column
            v-if="tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e) => e.private === undefined || e.private !== '').length"
            :exportable="false"
            :reorderableColumn="false"
            :header="TR.operation"
            :style="`width: ${tableOptions.row_buttons_width || '12'}rem;`"
            headerClass="text-center"
            bodyClass="text-center btnicon text-nowrap"
        >
            <template #body="{data}">
                <template v-for="(item, index) in tableOptions.row_buttons" :key="index">
                    <button
                        v-if="item.element == undefined && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))"
                        :class="`me-sm-21 rounded-circle btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null"
                    >
                        <i :class="`pt-13 ${typeof item.icon == 'function' ? item.icon(data) : item.icon}`"></i>
                        {{item.label}}
                    </button>

                    <router-link
                        v-else-if="item.element == 'router' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))"
                        :class="`me-sm-21 rounded-circle btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null"
                        :target="item.target || '_blank'"
                        :to="item.to !== undefined && typeof item.to === 'function' ? item.to(data) : item.to"
                    >
                        <i :class="`pt-13 ${item.icon}`"></i>
                        {{item.label}}
                    </router-link>

                    <div v-else-if="item.element == 'switch' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="form-switch d-inline-block mb-0 ms-2" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                        <input class="form-check-input" style="margin-top: 6px;" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                    </div>

                    <div v-else-if="item.element == 'checkbox' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="form-check d-inline-block mb-0 ms-2" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                        <input :id="'checkbox_' + index" class="form-check-input" style="margin-top: 6px;" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                        <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                    </div>

                </template>
            </template>
        </Column>

        <template v-if="tableOptions">
            <template v-for="(item, tcindex) in tableOptions.data_table_columns.filter(t => selectedColumns?.includes(t.name))" :key="tcindex">
                <Column
                    v-if="selectedColumns.length && selectedColumns?.includes(item.name) && item.private_column === undefined ? true : ( item.private_column && item.private_column == true ? false : true)"
                    :field="item.name"
                    :showFilterMatchModes="item.showFilterMatchModes === undefined || item.showFilterMatchModes ? true : false"
                    :header="item.title || item.name"
                    :exportable="item.exportable === undefined || item.exportable ? true : false"
                    :sortable="item.sortable === undefined || item.sortable ? true : false"
                    :dataType="item.data_type !== undefined && item.data_type ? item.data_type : 'text'"
                    :filterMenuStyle="{'width':'16rem'}"
                    :filterField="(item.filter === undefined || item.filter) && item.filter_field ? item.filter_field : item.name"
                    :maxConstraints="G.columnMaxConstraints"
                    :style="item.style || ''"
                    :class="item.class || ''"
                    :headerStyle="item.header_style || ''"
                    :headerClass="item.header_class || ''"
                    :bodyStyle="item.body_style || ''"
                    :bodyClass="item.body_class || ''"


                    :hidden="item.hidden !== undefined ? item.hidden : false"
                    >

                    <!--template v-if="item.element === undefined" #body="{data}">
                        <div v-if="item.filter_mode !== undefined && (item.filter_mode == 'date' || item.filter_mode == 'currency')" :class="item.class || ''">{{G.formatLocale(typeof item.value !== 'function' ? data[item.name] : item.value(data))}}</div>
                        <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class || ''"></div>
                    </template>
                    <template v-else-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)" #body="{data, index}">
                        <div v-if="item.element == 'switch'" class="d-flex justify-content-center">
                            <div class="form-check form-switch" :class="item.elementClass">
                                <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback($event, data)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            </div>
                        </div>
                        <div v-else-if="item.element == 'checkbox'">
                            <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback($event, data)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            <label :for="'checkbox_' + index" style="font-size: 0.75rem;" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                        </div>
                        <input v-else-if="item.element == 'text'" class="form-control" :class="item.elementClass" :value="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback($event, data)" type="text" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                        <button v-else-if="item.element == 'button'" :class="item.elementClass" @[item.eventName]="item.eventCallback($event, data)" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                            <i v-if="item.icon" :class="item.icon"></i>
                            <span>{{item.text}}</span>
                        </button>
                    </template-->

                    <template v-if="item.element === undefined" #body="{data, index}">
                        <div v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)" :class="item.class || ''" :style="item.style || ''">
                            <div v-if="item.filter_mode !== undefined && (item.filter_mode == 'date' || item.filter_mode == 'time' || item.filter_mode == 'datetime')" :class="item.class || ''" :style="item.style || ''">{{ data[item.name] && data[item.name] != '' && data[item.name] != null ? ( typeof item.value !== 'function' ? G.dateToStr(data[item.name], item.filter_mode) : item.value(data) ) : '' }}</div>

                            <div v-else-if="item.filter_mode !== undefined && item.filter_mode == 'currency'" :class="item.class || ''" :style="item.style || ''">{{ G.formatLocale(typeof item.value !== 'function' ? data[item.name] : item.value(data)) }}</div>

                            <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class !== undefined && typeof item.class === 'function' ? item.class(data) : item.class" :style="item.style !== undefined && typeof item.style === 'function' ? item.style(data) : item.style"></div>
                        </div>
                    </template>
                    <template v-else #body="{data, index}">
                        <div v-if="item.element == 'switch'" class="d-flex justify-content-center">
                            <div class="form-check form-switch" :class="item.elementClass">
                                <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            </div>
                        </div>

                        <div v-else-if="item.element == 'checkbox'">
                            <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                        </div>

                        <input v-else-if="item.element == 'text'" class="form-control" :class="item.elementClass" :value="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="text" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />

                        <button v-else-if="item.element == 'button'" :class="item.elementClass" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                            <i v-if="item.icon" :class="item.icon"></i>
                            <span>{{item.text}}</span>
                        </button>
                    </template>

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filter="{filterModel}"
                    >
                        <InputText
                            v-if="item.filter_mode === undefined || item.filter_mode == 'text'"
                            type="text"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            class="p-column-filter"
                            :placeholder="item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'numeric'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            :placeholder="item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'currency'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            mode="currency"
                            :currency="store.getCurrency()"
                            :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`"
                            :placeholder="item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'integer'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            :max="item.max"
                            :min="item.min"
                            :placeholder="item.title || ''"
                            integeronly
                        />

                        <InputMask
                            v-else-if="item.filter_mode == 'mask'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :mask="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                            :placeholder="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                        />

                        <DatePicker
                            v-else-if="item.filter_mode == 'date' || item.filter_mode == 'datetime'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :dateFormat="item.filter_format"
                            :showTime="item.showTime === undefined ? true : item.showTime"
                            :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                            :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                            :timeOnly="item.filter_mode == 'datetime' ? false : (item.timeOnly !== undefined ? item.timeOnly : false)"
                            :hourFormat="item.hourFormat || '24'"
                            :hideOnDateTimeSelect="true"
                            :showButtonBar="true"
                            :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                            :view="item.view_mode ? item.view_mode : 'date'"
                            :maxDate="item.maxDate || null"
                            :minDate="item.minDate || null"
                            showIcon fluid iconDisplay="input"
                        >
                            <template #inputicon="slotProps">
                                <i class="far fa-calendar-alt" @click="slotProps.clickCallback" />
                            </template>
                        </DatePicker>

                        <DatePicker
                            v-else-if="item.filter_mode == 'time'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :dateFormat="item.filter_format"
                            :showTime="item.showTime === undefined ? true : item.showTime"
                            :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                            :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                            :timeOnly="true"
                            :hourFormat="item.hourFormat || '24'"
                            :hideOnDateTimeSelect="true"
                            :showButtonBar="true"
                            :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                            :view="item.view_mode ? item.view_mode : 'date'"
                            :maxDate="item.maxDate || null"
                            :minDate="item.minDate || null"
                            showIcon fluid iconDisplay="input"
                        >
                            <template #inputicon="slotProps">
                                <i class="far fa-clock" @click="slotProps.clickCallback" />
                            </template>
                        </DatePicker>

                        <Select
                            v-else-if="item.filter_mode == 'dropdown'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :options="item.dropdown_items"
                            :filter="item.dropdown_items.length > 10 ? true : false"
                            optionValue="value"
                            optionLabel="label"
                            :placeholder="TR.select"
                            class="p-column-filter"
                            :showClear="true"
                        >
                            <template #value="slotProps">
                                <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.value) : item.dropdown_item_class"
                                    v-if="slotProps.value"
                                >{{item.dropdown_items.filter((e) => e.value == slotProps.value)[0].label}}</div>
                                <span v-else>{{slotProps.placeholder}}</span>
                            </template>
                            <template #option="slotProps">
                                <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                    v-html="slotProps.option.label"
                                ></div>
                            </template>
                        </Select>

                        <MultiSelect
                            v-else-if="item.filter_mode == 'multidropdown'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :options="item.dropdown_items"
                            :filter="item.dropdown_items.length > 10 ? true : false"
                            optionValue="value"
                            optionLabel="label"
                            :placeholder="TR.select"
                            :showClear="true"
                            display="chip"
                            :maxSelectedLabels="2"
                            :selectedItemsLabel="`{0} ${TR.data_category?.toLowerCase()} ${TR.selected?.toLowerCase()}`"
                        >
                            <template #option="slotProps">
                                <div class="d-flex align-items-center" style="width: 180px;">
                                    <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                    v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                                    ></div>
                                </div>
                            </template>
                            <template #dropdownicon>
                                <i class="fas fa-list" />
                            </template>
                        </MultiSelect>
                    </template>

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filterclear="{filterCallback}"
                    >
                        <Button
                            type="button"
                            icon="fas fa-times"
                            @click="filterCallback();resetFilter(item.filter_field ? item.filter_field : item.name)"
                            class="p-button-outlined p-button-primary"
                        ></Button>
                    </template>

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filterapply="{filterCallback}"
                    >
                        <Button
                            type="button"
                            icon="fas fa-check"
                            @click="filterCallback()"
                            class="p-button-primary"
                        ></Button>
                    </template>
                </Column>
            </template>
        </template>

        <ColumnGroup type="footer" :reorderableColumn="false" v-if="tableOptions.row_total !== undefined && tableOptions.row_total == true && tableOptions.data_table_columns !== undefined">
            <Row>
                <Column
                    :footer="TR.total"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, index) in tableOptions.data_table_columns" :key="index" :reorderableColumn="false">
                    <template #footer>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ pageTotal[item.name] }}</template>
                    </template>
                </Column>
            </Row>
        </ColumnGroup>

    </DataTable>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    // import { FilterOperator, FilterMatchMode, FilterService } from "primevue/api";
    import { FilterMatchMode, FilterOperator, FilterService } from '@primevue/core/api';

    import { G, ajax } from "@/_common";

    // import Dialog from "primevue/dialog";
    // import FileUpload from "primevue/fileupload";
    // import Toolbar from "primevue/toolbar";
    // import Rating from "primevue/rating";
    // import Textarea from "primevue/textarea";
    // import RadioButton from "primevue/radiobutton";
    import MultiSelect from "primevue/multiselect";
    import Button from "primevue/button";
    import InputMask from "primevue/inputmask";
    import InputText from "primevue/inputtext";
    import InputNumber from "primevue/inputnumber";
    import DatePicker from "primevue/datepicker";
    import Column from "primevue/column";
    import DataTable from "primevue/datatable";
    import Select from "primevue/select";
    import Row from "primevue/row";
    import ColumnGroup from "primevue/columngroup";

    import DADataTable from "@/components/table/DADataTable";

    // // Import from the browser build instead
    // import XLSX from 'xlsx/dist/xlsx.full.min';
    // // or for xlsx-style
    // import xlsx from 'xlsx-style/dist/xlsx.full.min';

    export default {
        name: 'DADataTableLazy',
        props: {
            tableOptions: {
                type: Object,
                default: () => {}
            },
            lazyUrl: {
                type: String,
                default: ''
            },
            lazyParam: {
                type: Object,
                default(){
                    return {
                        isDefault: true,
                        page: 1,
                        mainFilters: {},
                        filters: '',
                        whereIf: 'AND',
                    };
                }
            },
        },
        components: {
            // Toast,
            // Dialog,
            // FileUpload,
            // Toolbar,
            // Rating,
            // Textarea,
            // RadioButton,
            MultiSelect,
            Button,
            InputMask,
            InputText,
            InputNumber,
            Column,
            DataTable,
            Select,
            Row,
            ColumnGroup,
            DatePicker,

            // InputClear,
            DADataTable,
        },
        setup(props) {
            const store = useStore();
            const TR = ref({});

            const dt = ref({});
            const editingRows = ref();
            const selectedProducts = ref([]);
            const filters = ref({});
            const mainFilter = ref({});

            const rowsPerPage = props.tableOptions.rows || G.rowsPerPage;
            const rowsPerPageOptions = props.tableOptions.rowPerPageOptions || G.rowsPerPageOptions;

            const expandedRows = ref({});
            const expand_table_ref = ref();

            const onRowExpand = (event) => {
                props.tableOptions.onRowExpand(event.data);
            };
            const onRowCollapse = (event) => {
                props.tableOptions.onRowCollapse(event.data);
            };
            // const expandAll = () => {
            //     expandedRows.value = products.value.reduce((acc, p) => (acc[p.id] = true) && acc, {});
            // };
            // const collapseAll = () => {
            //     expandedRows.value = null;
            // };

            // FilterMatchMode['NOT_IN'] = 'not_in';
            // FilterMatchMode['CONTAINS_REG'] = 'contains_reg';

            const pageTotal = ref({});
            const tableData = ref([]);
            const loading = ref(false);
            const totalRecords = ref("");
            const lazyParams = ref({
                filters: props.lazyParam.filters || "",
                first: (props.lazyParam.page - 1) * rowsPerPage,
                // multiSortMeta: [],
                originalEvent: {
                    first: (props.lazyParam.page - 1) * rowsPerPage,
                    page: (props.lazyParam.page - 1 ),
                    // pageCount: 14,
                    rows: rowsPerPage
                },
                page: (props.lazyParam.page - 1),
                // pageCount: 14,
                rows: rowsPerPage,
                // sortField: null,
                // sortOrder: null
            });
            const lazyUrlLocal = ref(null);


            const selectedColumns = ref();
            const table_columns = ref();
            // const onToggle = (val) => {
            //     selectedColumns.value = props.tableOptions.data_table_columns.filter(col => val.includes(col.name));
            // };

            onMounted(async () => {
                lazyUrlLocal.value = props.lazyUrl;

                initFilter();

                if( props.lazyParam.isDefault === undefined ){
                    // lazyParams.value = {
                    //     // filters: "",
                    //     first: (props.lazyParam.page - 1) * rowsPerPage,
                    //     // multiSortMeta: [],
                    //     originalEvent: {
                    //         first: (props.lazyParam.page - 1) * rowsPerPage,
                    //         page: (props.lazyParam.page - 1 ),
                    //         // pageCount: 14,
                    //         // rows: 5
                    //     },
                    //     page: (props.lazyParam.page - 1),
                    //     // pageCount: 14,
                    //     // rows: 5,
                    //     // sortField: null,
                    //     // sortOrder: null
                    // };
                }
                else{
                    store.setDataTableParams({first: 0, page: 1, rows: rowsPerPage, mainFilters: {}, filters: '', whereIf: ''});
                }

                filters.value = props.lazyParam.mainFilters.global ? props.lazyParam.mainFilters : mainFilter.value;

                selectedColumns.value = props.tableOptions.data_table_columns.filter(e => e.visible == undefined || e.visible == true).map(e => e.name);

                await loadLazyData();
            });


            FilterService.register("customFilter", (value, fl) => {
                if (fl === undefined || fl === null) {
                    return true;
                }
                if (value === undefined || value === null) {
                    return false;
                }
                return value.toString() === fl.value.toString();
            });

            watchEffect(() => {
                TR.value = store.getTranslation();
                lazyUrlLocal.value = props.lazyUrl;

                props.tableOptions.globalFilterFields = props.tableOptions.data_table_columns
                    .reduce(
                        (acc, cur) => cur.name == "create_date" || cur.name == "update_date" ? acc : [...acc, cur.name],
                        []
                    );


                table_columns.value = props.tableOptions.data_table_columns.map(e => { return {"value": e.name, "label": e.title || e.name}; });
            });

            const clearFilter = () => {
                // lazyParams.value = {};
                // lazyParams.value.first = 0;

                dt.value.d_first = 0;

                store.setDataTableParams({first: 0, page: 1, rows: rowsPerPage, mainFilters: {}, filters: '', whereIf: ''});

                lazyParams.value = {
                    filters: "",
                    first: 0,
                    // multiSortMeta: [],
                    originalEvent: {
                        first: 0,
                        page: 0,
                        // pageCount: 14,
                        rows: rowsPerPage
                    },
                    page: 0,
                    // pageCount: 14,
                    rows: rowsPerPage,
                    // sortField: null,
                    // sortOrder: null
                };
                initFilter();

                filters.value = mainFilter.value;
                loadLazyData();
            };

            const resetFilter = (field) => {
                filters.value[field] = mainFilter.value[field];
            };

            const initFilter = () => {
                mainFilter.value = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                };
                if( props.tableOptions && props.tableOptions.data_table_columns ){
                    props.tableOptions.data_table_columns.forEach((e) => {
                        if (e.filters !== undefined){
                            mainFilter.value[e.filter_field ? e.filter_field : e.name] = e.filters;
                        }
                        else if (e.filter === undefined || e.filter) {
                            mainFilter.value[e.filter_field ? e.filter_field : e.name] = {
                                operator: FilterOperator.OR,
                                constraints: [
                                    {
                                        value: null,
                                        matchMode: FilterMatchMode.STARTS_WITH,
                                    },
                                ],
                            };
                        }
                    });
                }
                // BETWEEN: "between"
                // CONTAINS: "contains"
                // DATE_AFTER: "dateAfter"
                // DATE_BEFORE: "dateBefore"
                // DATE_IS: "dateIs"
                // DATE_IS_NOT: "dateIsNot"
                // ENDS_WITH: "endsWith"
                // EQUALS: "equals"
                // GREATER_THAN: "gt"
                // GREATER_THAN_OR_EQUAL_TO: "gte"
                // IN: "in"
                // LESS_THAN: "lt"
                // LESS_THAN_OR_EQUAL_TO: "lte"
                // NOT_CONTAINS: "notContains"
                // NOT_EQUALS: "notEquals"
                // STARTS_WITH: "startsWith"
            };

            const pageTotal1 = (field) => {
                let total = 0;
                if (tableData.value.length) {
                    for (let p of tableData.value) {
                        if( props.tableOptions.row_total_function !== undefined && props.tableOptions.row_total_function[field] !== undefined ){
                            total += props.tableOptions.row_total_function[field](p) || 0;
                        }
                        else{
                            total += p[field] || 0;
                        }
                    }
                }
                pageTotal.value[field] = G.formatLocale(total);
                // if (currentPageItems.value.length) {
                //     for (let p of currentPageItems.value) {
                //         total += p[field] || 0;
                //     }
                // }
                // pageTotal.value[field] = G.formatLocale(total);
            };

            const loadLazyData = async () => {
                if( lazyUrlLocal.value  ){
                    loading.value = true;

                    // const sortField1 = lazyParams.value ? Object.keys(lazyParams.value).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(lazyParams.value[k])).join('&') : '';

                    const sortField = Object.keys(lazyParams.value).length && lazyParams.value.multiSortMeta !== undefined ? lazyParams.value.multiSortMeta.map(k => encodeURIComponent(k.field) + ',' + encodeURIComponent(k.order)).join('.|.') : '';

                    const filters = Object.keys(lazyParams.value).length && lazyParams.value.filters !== undefined ? lazyParams.value.filters : '';
                    const whereIf = Object.keys(props.lazyParam).length && props.lazyParam.whereIf !== undefined ? props.lazyParam.whereIf : 'AND';

                    await ajax({
                        url: lazyUrlLocal.value + `?first=${lazyParams.value.first||0}&rows=${lazyParams.value.rows||5}&sortField=${sortField}&filters=${filters}&whereIf=${whereIf}`,
                        success: (e) => {
                            let res = e.data || null;
                            if( res && e.status == 200 ) {
                                loading.value = false;
                                totalRecords.value = res.total_records;

                                // console.log( G.dateToStr('2025-06-28T02:37:32.562618+04:00', 'datetime') );

                                ['create_date', 'update_date'].forEach(df => {
                                    res.data.forEach(x => {
                                        x[df] = (x[df] && x[df] != null && x[df] != '') ? new Date(G.dateToStr(x[df], 'pg_datetime')) : null;
                                    });
                                });

                                if( props.tableOptions && props.tableOptions.date_columns !== undefined ){
                                    let dtc = props.tableOptions.date_columns;
                                    Object.keys(dtc).forEach(df => {
                                        res.data.forEach(x => {
                                            x[df] = (x[df] && x[df] != null && x[df] != '') ? new Date(G.dateToStr(x[df], 'pg_datetime')) : null;
                                            // moment.utc(( x[df].split("+")[1].length > 5 ? x[df].slice(0, -3) : x[df] )).tz(G.systemData.timezone?.value).format(G.datetime_format[dtc[df]]) : null;
                                        });
                                    });
                                }

                                tableData.value = res.data;
                            }
                        },
                    }).then(() => {
                        loading.value = false;
                    });

                    reCalculateTotal();
                }
            };

            const reCalculateTotal = () => {
                if( props.tableOptions && props.tableOptions.row_total_field ){
                    props.tableOptions.row_total_field.forEach((field) => {
                        pageTotal1(field);
                    });
                }
            };

            const onPage = (event) => {
                lazyParams.value = event;
                generateParams(event.filters);
                loadLazyData();
            };
            const onSort = (event) => {
                lazyParams.value = event;
                // // Multiple sort object
                // console.log(event.multiSortMeta);
                generateParams(event.filters);
                loadLazyData();
            };
            const onFilter = () => {
                lazyParams.value.first = 0;
                generateParams(filters.value);
                loadLazyData();
            };

            const generateParams = (FILT) => {
                let x = [];

                for( var a in FILT ){
                    if( a != 'global' ){
                        let c = [];
                        let val;
                        FILT[a].constraints.forEach((b) => {
                            if( b.value != null ){
                                let re = RegExp(['create_date', 'update_date'].join('|'), "mgi");
                                // val = a.match(re) ? G.dateToStr(b.value, 'datetime') : b.value;
                                if( a.match(re) ){
                                    val = G.dateToStr(b.value, 'datetime');
                                }
                                else{
                                    val = b.value;
                                }

                                let ft = '';
                                if( props.tableOptions.date_columns !== undefined ){
                                    re = RegExp(Object.keys(props.tableOptions.date_columns).join('|'), "mgi");
                                    if( a.match(re) ){
                                        ft = props.tableOptions.date_columns[a] || 'datetime';
                                        val = G.dateToStr(b.value, 'datetime');
                                    }
                                }

                                c.push([ b.matchMode, a, val, ft ].join('.|.'));
                                // c.push([ b.matchMode, a, moment(b.value).tz(G.systemData?.timezone.value).format(G.datetime_format['datetime']) ].join('.|.'));
                            }
                            // else if( b.value == '' && [...["create_date", "update_date"], Object.keys(props.tableOptions.date_columns)].contains(a) ){
                            // else if( b.value == '' ){
                            //     c.push([ b.matchMode, a, '', ft ].join('.|.'));
                            // }
                        });
                        if( c.length ){
                            let z = '';
                            if( c.length > 1 )
                                z = FILT[a].operator + '$$'
                            x.push(z + c.join('$|$'));
                        }
                    }
                }
                // for( var a in filters.value ){
                //     if( a != 'global' ){
                //         let c = [];
                //         filters.value[a].constraints.forEach((b) => {
                //             if( b.value != '' && b.value != null )
                //                 c.push({'value': b.value, 'matchMode': b.matchMode});
                //         });
                //         if( c.length )
                //             x.push(c);
                //     }
                // }

                lazyParams.value.filters = x.join('@|@');
                return lazyParams.value.filters;
            };

            const tableRowClass = (data) => {
                // // return data.status === 0 ? 'bg-danger text-light': (data.status === 2 ? 'bg-warning text-light': data.status < 0 ? 'bg-secondary text-light' : '');
                // let rc = data.status === 0 ? 'bg-danger text-light': (data.status === 2 ? 'bg-warning text-light': data.status < 0 ? 'bg-secondary text-light' : '');
                // rc += props.tableOptions.row_class !== undefined && typeof props.tableOptions.row_class === 'function' ? props.tableOptions.row_class(data) : (props.tableOptions.row_class !== undefined ? ` ${props.tableOptions.row_class}` : '');

                let rc = [];
                rc.push(data.status == 0 || data.status == false ? 'bg-danger bg-opacity-25 text-secondary text-opacity-50': (data.status == 2 ? 'bg-dark bg-opacity-25': data.status < 0 ? 'bg-dark bg-opacity-75 text-light' : ''));
                rc.push(( (props.tableOptions.row_class !== undefined && typeof props.tableOptions.row_class === 'function') ? props.tableOptions.row_class(data) : (props.tableOptions.row_class !== undefined ? ` ${props.tableOptions.row_class}` : '') ))
                return rc.join(' ');
            };

            // const exportCSV = () => {
            //     dt.value.exportCSV();
            // };

            const expF = (obj) => {
                let {data, field} = obj;
                if( props.tableOptions.export_custom_fields !== undefined ){
                    let a = props.tableOptions.export_custom_fields;
                    for( let f in a ){
                        if( field == f ){
                            let c = a[f].split('.');
                            let d = tableData.value.filter(t => t[f] == data)[0];
                            c.forEach( x => d = d[x]);
                            data = d;
                        }
                    }
                }
                let ar = props.tableOptions.export_text_fields || ['content', 'note', 'source', 'result'];
                let ind = ar.indexOf(field);
                if( ind > -1 ){
                    let d = tableData.value.filter(t => t[ar[ind]] == data)[0];
                    d = G.stripTags(d[ar[ind]]);
                    data = d;
                }
                return data;

                // let dtc = props.tableOptions?.date_columns || {};
                // return ( Object.keys(dtc).filter(a => dtc[a] == 'datetime' &&  a == field).length > 0 )
                //     ? G.dateToStr(data, 'datetime')
                //     : (
                //         ( Object.keys(dtc).filter(a => dtc[a] == 'date' &&  a == field).length > 0 )
                //         ? G.dateToStr(data, 'date')
                //         : ( ( Object.keys(dtc).filter(a => dtc[a] == 'time' &&  a == field).length > 0 )
                //             ? G.dateToStr(data, 'time')
                //             : String(data)
                //           )
                //       )
                //     ;
            };

            const deleteSelectedProducts = () => {
                if( props.tableOptions.row_multiple_select !== undefined && props.tableOptions.row_multiple_select && props.tableOptions.row_multiple_delete !== undefined && typeof props.tableOptions.row_multiple_delete == 'function' ){
                    props.tableOptions.row_multiple_delete(selectedProducts.value.map(p => p.id));
                }
                // G.alert.confirm({ title: TR.value.warning, icon: 'question', msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes,
                //     yes: async () => {
                //         console.log(selectedProducts.value.map(p => p.id));

                //         // await ajax({
                //         //     url: store.getInformationBankUpdate(data.id),
                //         //     method: 'delete',
                //         //     success: (e) => {
                //         //         let res = e.data || null;
                //         //         if ( e.status == 200 && res){
                //         //             // tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                //         //             information_bank_table_ref.value.tableData.filter((x, i) => { if (x.id === data.id) information_bank_table_ref.value.tableData.splice(i, 1); } );
                //         //             information_bank_table_ref.value.reCalculateTotal();
                //         //             G.alert.success(res.detail);
                //         //         }
                //         //         else
                //         //             G.alert.error(res.detail);
                //         //     },
                //         // });
                //         // selectedProducts.value = null;
                //     }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {}
                // });
            };

            const exportCSV = (selectionOnly) => {
                dt.value.exportCSV({ selectionOnly });
            };

            const exportPdf = () => {
                // import('jspdf').then((jsPDF) => {
                //     import('jspdf-autotable').then(() => {
                //         let exportColumns = props.tableOptions.data_table_columns.map((col) => ({ title: col.title, dataKey: col.name }));

                //         // const doc = new jsPDF.default(0, 0);
                //         const doc = new jsPDF();

                //         doc.autoTable(exportColumns, dt.value.value);
                //         doc.save((props.tableOptions.export_filename || 'download') + '.pdf');
                //     });
                // });
            };

            const exportFile = async (extype) => {
                if( extype === undefined ){
                    extype = 'excel';
                }
                if(
                    ( ((selectedProducts.value.length != 0 && selectedProducts.value.length > 2000) || (selectedProducts.value.length == 0 && totalRecords.value > 2000)) && extype == 'word') ||
                    (( (selectedProducts.value.length != 0 && selectedProducts.value.length > 5000) || (selectedProducts.value.length == 0 && totalRecords.value > 5000)) && extype == 'excel') ){
                // if( totalRecords.value > 2000 ){
                    G.alert.warning(TR.value.msg_export_row_count_error);
                    return;
                }

                loading.value = true;
                // if( props.tableOptions.export_button_full !== undefined && props.tableOptions.export_button_full == true ){
                    const sortField = Object.keys(lazyParams.value).length && lazyParams.value.multiSortMeta !== undefined ? lazyParams.value.multiSortMeta.map(k => encodeURIComponent(k.field) + ',' + encodeURIComponent(k.order)).join('.|.') : '';
                    const filters = Object.keys(lazyParams.value).length && lazyParams.value.filters !== undefined ? lazyParams.value.filters : '';

                    const whereIf = Object.keys(props.lazyParam).length && props.lazyParam.whereIf !== undefined ? props.lazyParam.whereIf : 'AND';

                    let uri = lazyUrlLocal.value + `?first=${lazyParams.value.first||0}&rows=${lazyParams.value.rows||5}&sortField=${sortField}&filters=${filters}&whereIf=${whereIf}`;

                    let a = {};
                    let b = {};
                    let c = {};
                    let efr = props.tableOptions.export_custom_fields;
                    Object.keys(efr).forEach(w => {
                        // let w1 = w.split('.');
                        b[w] = efr[w].split('.')[0];
                    });
                    Object.values(efr).forEach(w => {
                        let w1 = w.split('.');
                        c[w1[0]] = w1.length > 2 ? w1.slice(1).join('.') : w1[1];
                    });
                    efr = b;
                    let coln = '';
                    props.tableOptions.data_table_columns.forEach((col) => {
                        if( selectedColumns.value.indexOf(col.name) > -1 && col.exportable !== false ){
                            coln = col.name;
                            if( efr[col.name] !== undefined ){
                                coln = efr[col.name];
                            }
                            a[coln] = col.title; //.replace(/\s/g, "_");
                        }
                    });

                    let ids = selectedProducts.value.length ? selectedProducts.value.map(d => d.id) : [];

                    let postData = {
                        columns: JSON.stringify(a),
                        export_columns: JSON.stringify(c),
                        // export_columns: JSON.stringify(props.tableOptions.export_custom_fields_excel),
                        date_columns: JSON.stringify(props.tableOptions.date_columns),
                        text_columns: JSON.stringify(props.tableOptions.export_text_fields),
                        sids: JSON.stringify(ids),
                        extype: extype
                    };

                    if( props.tableOptions.expandTableOptions !== undefined && props.tableOptions.expandTableOptions.data_table_columns !== undefined ){
                        let a_sub = {};
                        let b_sub = {};
                        let c_sub = {};
                        let efr_sub = props.tableOptions.expandTableOptions.export_custom_fields;

                        Object.keys(efr_sub).forEach(w => {
                            // let w1 = w.split('.');
                            b_sub[w] = efr_sub[w].split('.')[0];
                        });

                        Object.values(efr_sub).forEach(w => {
                            let w1 = w.split('.');
                            c_sub[w1[0]] = w1.length > 2 ? w1.slice(1).join('.') : w1[1];
                        });
                        efr_sub = b_sub;

                        coln = '';
                        props.tableOptions.expandTableOptions.data_table_columns.forEach((col) => {
                            if( props.tableOptions.expandTableOptions.selected_columns.indexOf(col.name) > -1 && col.exportable !== false ){
                                coln = col.name;
                                if( efr_sub[col.name] !== undefined ){
                                    coln = efr_sub[col.name];
                                }
                                a_sub[coln] = col.title;
                            }
                        });

                        Object.assign(postData, {
                            expand_field: props.tableOptions.expandTableOptions.expand_field,
                            columns_sub: JSON.stringify(a_sub),
                            export_columns_sub: JSON.stringify(c_sub),
                            date_columns_sub: JSON.stringify(props.tableOptions.expandTableOptions.date_columns),
                            text_columns_sub: JSON.stringify(props.tableOptions.expandTableOptions.export_text_fields),
                        });
                    }

                    // let efr = props.tableOptions.export_custom_fields_reg;
                    // props.tableOptions.data_table_columns.forEach((col) => {
                    //     if( selectedColumns.value.indexOf(col.name) > -1 && col.exportable !== false ){
                    //         let coln = col.name;
                    //         if( efr[col.name] !== undefined ){
                    //             coln = efr[col.name];
                    //         }
                    //         a[coln] = col.title; //.replace(/\s/g, "_");
                    //     }
                    // });

                    await ajax({
                        url: uri.replace('/lazy?', `/${extype}?`).replace('/search?', `/${extype}?`),
                        responseType: 'blob',
                        method: 'post',
                        content_type: 'application/json',
                        data: postData,
                        success: (e) => {
                            let res = e.data || null;
                            if( res && e.status == 200 ) {
                                const url = window.URL.createObjectURL(new Blob([res]));
                                const a = document.createElement('a');
                                a.href = url;
                                // Get filename from headers
                                const contentDisposition = e.headers['content-disposition'];
                                let filename = (props.tableOptions.export_filename || 'download') + (extype == 'word' ? '.docx' : '.xlsx');
                                if (contentDisposition) {
                                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                                    if (filenameMatch && filenameMatch[1]) {
                                        filename = filenameMatch[1];
                                    }
                                }
                                a.download = filename;
                                document.body.appendChild(a);
                                a.dispatchEvent(
                                    new MouseEvent('click', {
                                        bubbles: true,
                                        cancelable: true,
                                        view: window
                                    })
                                );
                                // a.click();
                                // Clean up
                                window.URL.revokeObjectURL(url);
                                document.body.removeChild(a);
                            }
                            else if( e.status == 404 ){
                                G.alert.error(e.detail);
                            }
                        }
                    });
                    loading.value = false;
                // }
            };

            // const exportExcelJS = () => {
                // else
                // {
                //     const ExcelJS = require('exceljs');

                //     const workbook = new ExcelJS.Workbook();

                //     workbook.creator = G.projectSubtitle2;
                //     workbook.lastModifiedBy = G.projectSubtitle2;
                //     workbook.created = new Date();
                //     workbook.modified = new Date();
                //     // workbook.lastPrinted = new Date(2016, 9, 27);

                //     const worksheet = workbook.addWorksheet('Data');

                //     // Add header row based on keys of the first object
                //     let a = {};
                //     props.tableOptions.data_table_columns.forEach((col) => {
                //         if( selectedColumns.value.indexOf(col.name) > -1 && col.exportable !== false ){
                //             a[col.name] = col.title; //.replace(/\s/g, "_");
                //         }
                //     });
                //     const columns = Object.keys(a).map(k1 => ({ header: a[k1], key: k1, width: 12, style: {alignment: { vertical: 'top', horizontal: 'center', wrapText: true }} })); //Object.keys(data[0]).map(key => ({ header: key.toUpperCase(), key }));
                //     worksheet.columns = [{ header: 's/s', key: 'rn', width: 6, style: {alignment: { vertical: 'top', horizontal: 'center' }} }, ...columns];

                //     // Add rows
                //     let dtdata = selectedProducts.value.length ? selectedProducts.value : dt.value.value;

                //     let b = [];
                //     let xc = [];
                //     // Export fields text alternatives if column have foreign_id
                //     let ef = props.tableOptions.export_custom_fields;
                //     dtdata.forEach((d, i) => {
                //         b[i] = {};
                //         columns.forEach(cf => {
                //             let k = cf.key;
                //             let dtc = props.tableOptions.data_table_columns.filter(f => f.name == k);
                //             if( dtc.length > 0 && (dtc[0].exportable === undefined || dtc[0].exportable === true) ){
                //                 let ind = Object.keys(ef).indexOf(k);
                //                 let f = [];
                //                 let q = d;
                //                 if( ind > -1 ){
                //                     f = ef[k].split(".")
                //                     f.forEach( x => q instanceof Array ? q = q.map(xx => xx[x]) : q = q ? q[x] : null);
                //                     b[i][k] = q instanceof Array ? q.join(', ') : q;
                //                 }
                //                 else if( props.tableOptions.export_text_fields.indexOf(k) > -1 ){
                //                     b[i][k] = q && q[k] && q[k] != null && q[k] != '' ? G.stripTags(q[k]).replace(/\r/mgi, '') : q[k];
                //                     // b[i][k] = props.tableOptions.export_text_fields.indexOf(k) != -1 && q[k] && q[k] != null && q[k] != '' ? G.stripTags(q[k]).replace(/\r/mgi, '') : q[k];
                //                     // b[i][k] = ind != -1 ? d[f[0]][f[1]] : d[k];
                //                     // b[i][k] = q[k] && q[k] != null && q[k] != '' ? q[k].toString().replace(/\r/mgi, '') : q[k];
                //                     xc.push(k);
                //                 }
                //                 else{
                //                     b[i][k] = q[k];
                //                 }
                //             }
                //         });
                //     });

                //     // b.forEach(item => {
                //     //     worksheet.addRow(Object.values(item));
                //     // });
                //     worksheet.addRows(b);

                //     xc.forEach((x) => {
                //         let cols = worksheet.getColumn( x )
                //         cols.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
                //         // cols.eachCell((cell) => {
                //         //     cell.value = {
                //         //         richText: [
                //         //             {'font': { 'color': {'argb': 'FFe36209'} }, 'text': 'test'},
                //         //         ]
                //         //     };
                //         // });
                //     });

                //     worksheet.getRow(1).eachCell((cell) => {
                //         cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                //         cell.fill = {
                //             type: 'pattern',
                //             pattern:'solid',
                //             fgColor:{ argb:'FF055D04' }
                //         };
                //         cell.alignment = { vertical: 'middle', horizontal: 'center' };
                //     });

                //     worksheet.getCell('A2').value = 1;
                //     worksheet.fillFormula(`A3:A${b.length+1}`, 'A2+1', (row, col) => row);

                //     // worksheet.eachRow((row, rownum) => {
                //     //     // worksheet.getRow(1).eachCell((cell) => {
                //     //     row.eachCell((cell, colnum) => {
                //     //         if( cell._column._key == 'image' && cell.value.startsWith('http') ){
                //     //             // const imageId1 = workbook.addImage({
                //     //             //     filename: cell.value,
                //     //             //     extension: 'jpeg',
                //     //             // });
                //     //             // worksheet.addImage(imageId1, {
                //     //             //     tl: { col: colnum, row: rownum },
                //     //             //     ext: { width: 140, height: 80 }
                //     //             // });
                //     //         }
                //     //     });
                //     // });

                //     // // Optional: Auto-width for columns
                //     // worksheet.columns.forEach(column => {
                //     //     const maxLength = Math.max(
                //     //     column.header.length,
                //     //     ...data.map(row => row[column.key]?.toString().length || 0)
                //     //     );
                //     //     column.width = maxLength + 2;
                //     // });

                //     const excelBuffer = await workbook.xlsx.writeBuffer();

                //     // Save to file
                //     // await workbook.xlsx.writeFile(props.tableOptions.export_filename || 'download');
                //     saveAsExcelFile(excelBuffer, props.tableOptions.export_filename || 'download');
                // }
            // };

            const saveAsExcelFile = (buffer, fileName) => {
                // import('file-saver').then((module) => {
                //     if (module && module.default) {
                //         let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                //         let EXCEL_EXTENSION = '.xlsx';
                //         // let data = window.URL.createObjectURL(new Blob([buffer], {
                //         //     type: EXCEL_TYPE
                //         // }));
                //         const data = new Blob([buffer], {
                //             type: EXCEL_TYPE
                //         });

                //         // module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
                //         module.default.saveAs(data, fileName + EXCEL_EXTENSION);
                //         // window.URL.revokeObjectURL(data);
                //     }
                // });
            };

            return {
                G,
                TR,
                moment,
                store,
                dt,

                tableData,
                loading,
                totalRecords,
                lazyParams,
                // lazyUrl,
                onPage,
                onSort,
                onFilter,


                editingRows,
                rowsPerPage,
                rowsPerPageOptions,
                selectedProducts,
                filters,
                exportCSV,
                exportFile,
                exportPdf,
                expF,
                deleteSelectedProducts,

                clearFilter,
                resetFilter,
                pageTotal,
                loadLazyData,
                tableRowClass,
                reCalculateTotal,
                generateParams,

                selectedColumns,
                // onToggle,
                table_columns,


                expandedRows,
                onRowExpand,
                onRowCollapse,
                // expandAll,
                // collapseAll,

                expand_table_ref,
            };
        },
    };
</script>


<style lang="scss">
.dtlazy-main{
    .form-check{
        min-height: 0px;
    }
    .btnicon button{
        width: 38px;
        height: 38px;
        text-align: center;
    }
    .btnicon i{
        width: 16px;
        height: 16px;
    }
    .p-multiselect-label.p-multiselect-label-empty, .p-multiselect-label{
        display: none;
    }
    .p-multiselect-header{
        background-color: rgba(var(--bs-secondary-rgb), .1);
        align-items: center;
        padding: 10px 15px;
    }
    .p-datatable-popover-filter {
        margin-inline-start: unset;
    }
    .p-datatable-column-title{
        padding-right: .5rem;
    }
    th, td{
        border: 1px solid rgba(225, 225, 225, 0.4) !important;
    }
    .p-datatable-column-header-content {
        display: inline-flex;
    }
    .form-check .form-check-input {
        float: unset;
    }
    table{
        border-collapse: unset;
    }
    .p-datatable-row-expansion{
        background-color: var(--bs-gray-300);
    }
}
</style>
